import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { IntlProps } from 'ha/i18n';
import { CanonicalCollections } from 'ha/constants/SearchPageCollections';

interface Props {
  canonicalCollection: string;
  city: string;
}

export const SearchCollectionSubtitle: React.SFC<Props & IntlProps> = ({
  canonicalCollection,
  city,
  intl: { T },
}) => {
  const subtitle = {
    [CanonicalCollections.ApartmentForRent]: T(
      'seo_search_h2_apartment_for_rent',
      city,
      city,
    ),
    [CanonicalCollections.PrivateRoomForRent]: T(
      'seo_search_h2_private_room_for_rent',
      city,
      city,
    ),
    [CanonicalCollections.SharedRoomForRent]: T(
      'seo_search_h2_shared_room_for_rent',
      city,
      city,
    ),
    [CanonicalCollections.StudioForRent]: T(
      'seo_search_h2_studio_for_rent',
      city,
      city,
    ),
    [CanonicalCollections.CheapAccommodation]: T(
      'seo_search_h2_cheap_accommodation',
      city,
      city,
    ),
    [CanonicalCollections.FurnishedApartments]: T(
      'seo_search_h2_furnished_apartments',
      city,
      city,
    ),
    [CanonicalCollections.StudentAccommodation]: T(
      'seo_search_h2_student_accommodation',
      city,
      city,
    ),
    [CanonicalCollections.LongTermRentals]: T(
      'seo_search_h2_long_term_rentals',
      city,
      city,
    ),
    [CanonicalCollections.OneBedroomApartments]: T(
      'seo_search_h2_one_bedroom_apartments',
      city,
      city,
    ),
    [CanonicalCollections.TwoBedroomApartments]: T(
      'seo_search_h2_two_bedroom_apartments',
      city,
      city,
    ),
    [CanonicalCollections.StudentRoom]: T(
      'seo_search_h2_student_room',
      city,
      city,
    ),
    '': T('seo_search_h2', city, city),
  }[canonicalCollection];

  return <Typography variant="subheading">{subtitle}</Typography>;
};

export default SearchCollectionSubtitle;
